import { MovieClip } from '@play-co/timestep-core/ui';
import { Container, Sprite, Texture } from '../../../odie';
import { ThrowerBlockProps } from '../../defs/block';
import { getMatch2AssetPath } from '../../util/assets';
import { blockPositionView } from '../../util/blockTools';

const manifestEnabled = () => ({
  cage: 'cage/block.cage.front.png',
  movieclip: {
    url: getMatch2AssetPath('blocks/cage/thrower'),
    loadMethod: MovieClip.animationLoader,
  },
});

/*
    thrower block view
*/
export class ThrowerBlockView extends Container {
  // fields
  //-------------------------------------------------------------------------
  // scene
  private _sprite!: Sprite;
  private _animation!: MovieClip;
  // state
  private _enabled = true;

  // properties
  //-------------------------------------------------------------------------
  public get enabled(): boolean {
    return this._enabled;
  }

  public set enabled(value: boolean) {
    // update field
    this._enabled = value;

    this._animation.loop(`soap_${value ? 'active' : 'inactive'}`);
  }

  // init
  //-------------------------------------------------------------------------
  constructor(props: ThrowerBlockProps) {
    // spawn
    super();

    this._animation = new MovieClip({
      superview: this.view,
      url: getMatch2AssetPath('blocks/cage/thrower'),
      defaultAnimation: 'soap_active',
      scale: 0.9,
    });

    // position
    blockPositionView(this, props);
  }

  public static assets() {
    return Object.values(manifestEnabled());
  }
}
